import { render, staticRenderFns } from "./SidebarCollapse.vue?vue&type=template&id=028e2488&scoped=true"
import script from "./SidebarCollapse.vue?vue&type=script&lang=js"
export * from "./SidebarCollapse.vue?vue&type=script&lang=js"
import style0 from "./SidebarCollapse.vue?vue&type=style&index=0&id=028e2488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e2488",
  null
  
)

export default component.exports